import { deepMerge } from '@fortem-monorepo/js-utilities';
import { FortemSDKError, buildUrl } from '../shared';
import { prepareBody } from './body';
import { responseTypes } from './constants';
import { buildHeaders } from './headers';
import { parseErrorResponse } from './parse-error-response';
import { parseResponse } from './parse-response';
const DEFAULT_CONFIG = {
    defaultOptions: { responseType: responseTypes.Json },
};
export class HTTPClient {
    config;
    constructor(config = {}) {
        this.config = deepMerge(DEFAULT_CONFIG, config);
    }
    async request(path, options = {}) {
        const { params: defaultParams, responseType: defaultResponseType, headers: defaultHeaders, ...defaultFetchOptions } = this.config.defaultOptions ?? {};
        const { params, responseType: overrideResponseType, headers, body, ...fetchOptions } = options;
        const responseType = overrideResponseType ?? defaultResponseType ?? responseTypes.Json;
        const token = await this.config.getToken?.();
        let response = null;
        try {
            response = await fetch(buildUrl(path, this.config.baseUrl, { ...defaultParams, ...params }), {
                ...defaultFetchOptions,
                ...fetchOptions,
                body: prepareBody(body),
                headers: buildHeaders({
                    defaultHeaders,
                    overrideHeaders: headers,
                    token,
                    body,
                    responseType,
                }),
            });
        }
        catch (error) {
            throw new FortemSDKError('Something went wrong while contacting the API. Please try again or contact Tech.', 'NETWORK_ERROR', 0, error);
        }
        if (!response.ok) {
            throw await parseErrorResponse(response);
        }
        return parseResponse(response, responseType);
    }
    async get(path, options = {}) {
        return this.request(path, { ...options, method: 'GET' });
    }
    async post(path, options = {}) {
        return this.request(path, { ...options, method: 'POST' });
    }
    async patch(path, options = {}) {
        return this.request(path, { ...options, method: 'PATCH' });
    }
    async put(path, options = {}) {
        return this.request(path, { ...options, method: 'PUT' });
    }
    async delete(path, options = {}) {
        return this.request(path, { ...options, method: 'DELETE' });
    }
}
